import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import { frostedPanelSx } from 'src/common/styles/frostedPanelStyles';
import { mergeRecommendedSignupLayout } from 'src/helpers/signupPageLayoutUtils';
import { IPageDocument } from 'src/helpers/pageDocumentUtils';
import { IBasePageContent } from 'src/interfaces/PageContent';

const panelSx = {
  ...frostedPanelSx(0.5),
  p: { xs: 2, sm: 3 },
  mb: 2,
  mt: 2,
};

interface Props {
  document: IPageDocument;
  pageContent?: IBasePageContent;
  onDocumentChange: (doc: IPageDocument) => void;
}

export default function SignupPageBlocksPanel({
  document,
  pageContent,
  onDocumentChange,
}: Props) {
  const { t } = useTranslation();

  const handleResetLayout = () => {
    onDocumentChange(mergeRecommendedSignupLayout(document, pageContent));
  };

  return (
    <Paper variant="outlined" sx={panelSx}>
      <Typography variant="subtitle1" sx={{ fontWeight: 600 }} gutterBottom>
        {t('system.pages.signupLayout.title')}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        {t('system.pages.signupLayout.description')}
      </Typography>
      <Box component="ul" sx={{ m: 0, pl: 2.5, mb: 2 }}>
        <Typography component="li" variant="body2" color="text.secondary">
          {t('system.pages.signupLayout.roleIntro')}
        </Typography>
        <Typography component="li" variant="body2" color="text.secondary">
          {t('system.pages.signupLayout.roleFlow')}
        </Typography>
        <Typography component="li" variant="body2" color="text.secondary">
          {t('system.pages.signupLayout.roleEmbedded')}
        </Typography>
        <Typography component="li" variant="body2" color="text.secondary">
          {t('system.pages.signupLayout.roleClosed')}
        </Typography>
        <Typography component="li" variant="body2" color="text.secondary">
          {t('system.pages.signupLayout.roleSuccess')}
        </Typography>
      </Box>
      <Button variant="outlined" color="primary" onClick={handleResetLayout}>
        {t('system.pages.signupLayout.resetButton')}
      </Button>
    </Paper>
  );
}
